<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">FOREWORD</h2>
<p class="noindent">With the heart of a pastor, mind of a scholar and discipline of an athlete, Shonn Keels provides this most timely and practical resource based on his uniquely personal insights gleaned from the apostle Paul’s letter to the church at Philippi. As the effects of the global pandemic continue unabated, Shonn skillfully guides the reader through the lessons taught us by the apostle who faced his own daunting challenges at Philippi yet miraculously experienced God’s peace and joy through them all. Our understanding and application of these lessons and the principles that emanate from them will most certainly help us as we navigate our own current set of trials. Your faith will be encouraged, mind challenged, and heart strengthened as you read and apply these most pertinent lessons from this uniquely helpful book.</p>
<p class="indent">One of life in the ministry’s great honors lies with relationships built during this journey of service. One of those highlights for me was the time spent serving with Shonn Keels and his precious family. Shonn, because of his military and athletic background, possesses a rare ability to effectively relate to a wide array of people of which I observed him do with great regularity. Additionally, Shonn does all this with both a humble spirit and a bold witness for our Lord. Through the years God has allowed our paths to cross from time to time and each time I have come away enriched and refreshed. As you read this book, I believe your experience will be the same.</p>
<p class="indent-top"><span class="aitalic">Jim Austin</span></p>
<p class="indent">Dr. Jim Austin</p>
<p class="indent">Executive Director/Treasurer,</p>
<p class="indent">South Carolina Baptist Convention, Retired</p>
<p class="indent">Columbia, South Carolina</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?2367bbaf